import React from "react";
import { FieldValues, FieldError } from "react-hook-form";

interface FormInputProps {
  label: string;
  name: string;
  type?: string;
  placeholder?: string;
  register: FieldValues;
  errors: FieldError | undefined;
  touchedFields: Record<string, boolean>;
  icon?: React.ReactElement;
}

const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  type = "text",
  placeholder,
  register,
  errors,
  touchedFields,
  icon,
}) => {
  return (
    <div className="w-full max-w-lg">
      <label className="block text-sm font-medium flex flex-row justify-between">
        {label}
        {icon}
      </label>
      {type === "checkbox" ? (
        <input
          type="checkbox"
          className={`toggle toggle-primary ${
            errors
              ? "border-2 border-error"
              : touchedFields[name]
              ? "border-2 border-success"
              : ""
          }`}
          {...register}
        />
      ) : (
        <input
          type={type}
          placeholder={placeholder}
          {...register}
          className={`w-full bg-base-200 p-2 rounded ${
            errors
              ? "border-2 border-error"
              : touchedFields[name]
              ? "border-2 border-success"
              : ""
          }`}
        />
      )}
      {errors && <p className="text-red-500 text-sm">{errors?.message}</p>}
    </div>
  );
};

export default FormInput;
